import React from 'react';
import { useTranslatedText } from '../i18n/useTranslatedText.js';
import './Footer.css';

const Footer = () => {
  const eventsText = useTranslatedText('Etkinlikler');
  const aboutText = useTranslatedText('Hakkımızda');
  const createEventText = useTranslatedText('Etkinlik Oluştur');
  const myEventsText = useTranslatedText('Benim Etkinliklerim');
  const newsText = useTranslatedText('Yeni Etkinliklerden Haberdar Ol');
  const subscribeText = useTranslatedText('Abone Ol');
  const createdByText = useTranslatedText('Copyright 2024 All Rights Reserved INTEGRA 3646 Tarafından Oluşturuldu');
  const emailPlaceholder = useTranslatedText('E-posta:');

  return (
    <footer className="footer">
      <div className="footer-columns">
        <div className="footer-column">
          <h4>SteamNearMe</h4>
          <a href="https://integra3646.com" target="_blank" rel="noopener noreferrer">
            {aboutText}
          </a>
          <p>
            <a href="https://integra3646.com" target="_blank" rel="noopener noreferrer">
              INTEGRA 3646
            </a>
          </p>
          <p>{emailPlaceholder} integra3646@gmail.com</p>
        </div>
        <div className="footer-column">
          <h4>{eventsText}</h4>
          <a href="/etkinlik-oluştur">{createEventText}</a>
          <a href="/benim-etkinliklerim">{myEventsText}</a>
        </div>
        <div className="footer-column">
          <h4>{newsText}</h4>
          <input type="email" placeholder={emailPlaceholder} />
          <button>{subscribeText}</button>
        </div>
      </div>
      <div className="copyright">
        <p>
          <a href="https://integra3646.com" target="_blank" rel="noopener noreferrer">
            {createdByText}
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
